import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  add_remark_to_interview_kit_data_action,
  assessment_kit_question_skill_rating_mentor_action,
  create_shortlisting_candidate_action,
  get_all_candidate_public_assessment_kits_videos_data_action,
  get_loggedin_user_meta_data_action,
  review_interview_kit_candidate_action,
  update_assessment_kit_question_skill_rating_mentor_action,
  update_remark_to_interview_kit_data_action,
} from "../../../redux/_actions";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
import { useNavigate } from "react-router-dom";
function useViewAssessmentVideoNew() {
  const url = new URL(window.location.href);
  const applicationId = url.searchParams.get("applicant");
  const interviewKitId = url.searchParams.get("interviewKit");
  const candidateId = url.searchParams.get("candidate");
  const stored_user =
    localStorage.getItem("jigsawUser") &&
    JSON.parse(localStorage.getItem("jigsawUser"));

  const userInLocalStorage = JSON.parse(localStorage.getItem("jigsawUser"));
  const [interviewKitReview, setInterviewKitReview] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userMeta, setUserMeta] = useState({});
  const [defaultRemark, setDefaultRemark] = useState(null);
  const [isEditRemark, setIsEditRemark] = useState(false);
  const [question, setQuestion] = useState(null);
  const [questionIndex, setQuestionIndex] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [nextPage, setNextPage] = useState(null);
  const [pageNum, setPageNum] = useState(1);

  const { interviewKitReviewData } = useSelector(
    (state) => state.review_interview_kit_candidate_reducer
  );

  const { loggedInMetaData } = useSelector(
    (state) => state.get_loggedin_user_meta_data_reducer
  );

  const { updatedRemarkData } = useSelector(
    (state) => state.update_remark_to_interview_kit_data_reducer
  );

  const { AddedRemark } = useSelector(
    (state) => state.add_remark_to_interview_kit_data_reducer
  );

  useEffect(() => {
    setLoading(true);
    if (loggedInMetaData?.data) {
      setUserMeta(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);

  useEffect(() => {
    setLoading(true);

    const getInterviewVideos = async () => {
      if (stored_user) {
        await dispatch(get_loggedin_user_meta_data_action());
      }
      if (interviewKitId) {
        //signedin api
        if (candidateId) {
          if (
            stored_user?.user &&
            stored_user.user?.role === "hiring_manager"
          ) {
            callApi(interviewKitId, candidateId);
          } else callPublicApi(interviewKitId, candidateId);
        } else if (applicationId) {
          callApi(interviewKitId, applicationId);
        } //public api
      }
    };

    getInterviewVideos();
  }, []);

  useEffect(() => {
    if (nextPage) {
      //signedin api
      if (applicationId) {
        callApi(interviewKitId, applicationId, pageNum);
      } //public api
      else if (candidateId) {
        if (stored_user?.user && stored_user.user?.role === "hiring_manager") {
          callApi(interviewKitId, candidateId);
        } else callPublicApi(interviewKitId, candidateId);
      }
    }
  }, [pageNum]);

  useEffect(() => {
    if (updatedRemarkData && updatedRemarkData?.data) {
      setDefaultRemark(updatedRemarkData?.data);
      setIsEditRemark(false);
    }
  }, [updatedRemarkData]);

  useEffect(() => {
    if (AddedRemark && AddedRemark?.data) {
      setDefaultRemark(AddedRemark?.data);
      setIsEditRemark(false);
    }
  }, [AddedRemark]);

  useEffect(() => {
    if (updatedRemarkData && updatedRemarkData?.data) {
      setDefaultRemark(updatedRemarkData?.data);
      setIsEditRemark(false);
    }
  }, [updatedRemarkData]);

  useEffect(() => {
    if (interviewKitReviewData?.data) {
      let data = interviewKitReviewData.data?.results;
      let results = [];
      if (pageNum === 1) {
        results = data;
        setInterviewKitReview(data);
      } else {
        results = interviewKitReview;
        data.forEach((newItem) => {
          if (!results.find((item) => item.id === newItem.id)) {
            results.push(newItem);
          }
        });
        setInterviewKitReview(results);
      }
      let questionData;

      if (questionIndex === null) {
        questionData = results[0];
      } else {
        questionData = results[questionIndex];
      }
      setQuestion(questionData);
      setNextPage(interviewKitReviewData.data?.next);
      setDefaultRemark(data[0] && data[0].remark);
      setIsEditRemark(false);
    }
  }, [interviewKitReviewData]);

  const callApi = async (id, applicantId) => {
    // setLoading(true);

    await dispatch(
      review_interview_kit_candidate_action(id, applicantId, pageNum)
    );
    setLoading(false);
  };

  const callPublicApi = async (id, candidateId) => {
    setLoading(true);
    await dispatch(
      get_all_candidate_public_assessment_kits_videos_data_action(
        id,
        candidateId,
        pageNum
      )
    );
    setLoading(false);
  };

  const onQuestionRatingChange = async (value) => {
    if (userMeta?.id === question.question_detail?.created_by) {
      let url = new URL(window.location.href);
      let interviewKitId = url.searchParams.get("interviewKit");
      let data = {
        candidate: question?.candidate,
        interview_kit: parseInt(interviewKitId),
        question: question?.question,
        skill:
          question?.question_detail &&
          question.question_detail?.skills &&
          question.question_detail.skills[0],
        rating: value,
      };
      if (question?.rating && question.rating?.id)
        await dispatch(
          update_assessment_kit_question_skill_rating_mentor_action(
            question?.rating && question.rating?.id,
            data
          )
        );
      else
        await dispatch(
          assessment_kit_question_skill_rating_mentor_action(data)
        );
      if (interviewKitId) {
        //signedin api
        if (candidateId) {
          if (
            stored_user?.user &&
            stored_user.user?.role === "hiring_manager"
          ) {
            callApi(interviewKitId, candidateId);
          } else callPublicApi(interviewKitId, candidateId);
        } else if (applicationId) {
          callApi(interviewKitId, applicationId);
        } //public api
      }
    } else
      showWarningMessage("You don't have permission to perform this action.");
  };

  const onBlurInput = async (e) => {
    let url = new URL(window.location.href);
    let interviewKitId = url.searchParams.get("interviewKit");
    let applicationId = url.searchParams.get("applicant");
    const value = e.target.value;
    const data = {
      remarked_by: userInLocalStorage?.user && userInLocalStorage.user?.id,
      interview_kit: interviewKitId,
      candidate: applicationId || candidateId,
      remark: value,
    };

    if (value !== "") {
      if (defaultRemark) {
        await dispatch(
          update_remark_to_interview_kit_data_action(data, defaultRemark?.id)
        );
      } else {
        await dispatch(add_remark_to_interview_kit_data_action(data));
      }
    } else {
      showWarningMessage("Please Enter Remark");
    }
  };

  const onEditRemark = () => {
    setIsEditRemark(!isEditRemark);
  };
  const onNavigateBack = () => navigate(-1);

  const onQuestionViewClick = (event) => {
    const selectedQuestion = event.target.value;
    let index = interviewKitReview.findIndex(
      (obj) =>
        obj.question_detail && obj.question_detail.question === selectedQuestion
    );

    if (index >= 0 && index < interviewKitReview.length) {
      let data = interviewKitReview[index];
      setQuestion(data);
      setQuestionIndex(index);
    }
  };

  const onClickShortlist = async (candidateId) => {
    if (interviewKitId) {
      const data = {
        candidate: candidateId,
        interview_kit: interviewKitId,
      };
      await dispatch(create_shortlisting_candidate_action(data));
    }
  };

  const onNextPrevClick = (id, type) => {
    let value = type === "add" ? 1 : type === "sub" ? -1 : 0;
    let index = interviewKitReview.findIndex((obj) => obj.id === id) + value;

    if (index >= 0 && index < interviewKitReview.length) {
      let data = interviewKitReview[index];
      setQuestion(data);
      setQuestionIndex(index);
    }
  };

  return {
    interviewKitReview,
    question,
    loading,
    defaultRemark,
    isEditRemark,
    userMeta,
    questionIndex,
    onQuestionRatingChange,
    onBlurInput,
    onEditRemark,
    onNavigateBack,
    onQuestionViewClick,
    onClickShortlist,
    onNextPrevClick,
  };
}

export default useViewAssessmentVideoNew;
